import { useEffect, useState } from "react";
import { UploadOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Popconfirm } from "antd";
import {
  getAll,
  uploadSlikaGalerija,
  deleteSlikaGalerija,
} from "../../services/slikaGalerija.service";
import Background from "../../components/Background4";
import "./GalerijaPage.css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const GalerijaPage = () => {
  const [slike, setSlike] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchSlike();
  }, []);

  const fetchSlike = async () => {
    try {
      const res = await getAll();
      setSlike(res.data);
    } catch (err) {
      alert("Greška pri dohvatanju slika.");
    }
  };
  const handlePreview = (index) => {
    setCurrentIndex(index);
    setPreviewVisible(true);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = Array.from(e.dataTransfer.files);

    for (const file of files) {
      try {
        await uploadSlikaGalerija(file);
      } catch (err) {
        alert("Greška prilikom dodavanja slike.");
      }
    }
    fetchSlike();
  };

  const handleDelete = async (id) => {
    try {
      await deleteSlikaGalerija(id);
      setSlike((prev) => prev.filter((s) => s.id !== id));
    } catch (err) {
      alert("Greška prilikom brisanja slike.");
    }
  };

  const slikeZaGaleriju = slike.map((s) => ({
    original: s.putanja,
    thumbnail: s.putanja,
  }));

  const handleGalerijaChange = async (e) => {
    const files = Array.from(e.target.files);

    for (const file of files) {
      try {
        await uploadSlikaGalerija(file);
      } catch (err) {
        alert("Greška prilikom dodavanja slike.");
      }
    }

    fetchSlike();
  };

  return (
    <div>
      <Background />
      <div className="galerija-container">
        <div className="galerija-zamuceni">
          <div className="dodavanje-slika-button">
            <Button
              type="primary"
              icon={<UploadOutlined />}
              style={{ width: "250px", height: "50px" }}
              onClick={() => setShowUploadModal(true)}
            >
              Dodaj sliku
            </Button>
          </div>
          <div
            className="pregled-galerije"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            <div className="galerija-grid">
              {slike.map((slika, index) => (
                <div key={slika.id} className="galerija-item">
                  <div className="galerija-image-wrapper">
                    <img
                      src={slika.putanja}
                      alt={`Slika ${index}`}
                      className="galerija-slika"
                      onClick={() => handlePreview(index)}
                    />
                  </div>
                  <Popconfirm
                    title="Da li ste sigurni da želite obrisati sliku?"
                    onConfirm={() => handleDelete(slika.id)}
                    okText="Da"
                    cancelText="Ne"
                  >
                    <Button
                      danger
                      icon={<CloseOutlined />}
                      className="galerija-delete-button"
                    >
                      Obriši
                    </Button>
                  </Popconfirm>
                </div>
              ))}
            </div>
          </div>
          <Modal
            open={showUploadModal}
            footer={null}
            onCancel={() => setShowUploadModal(false)}
            centered
            width="auto"
          >
            <div
              className={`galerija-drop-zone ${dragOver ? "drag-over" : ""}`}
              onDrop={handleDrop}
              onDragOver={(e) => {
                e.preventDefault();
                setDragOver(true);
              }}
              onDragLeave={() => setDragOver(false)}
              style={{ textAlign: "center", padding: 30 }}
            >
              <UploadOutlined style={{ fontSize: 32, color: "#999" }} />
              <p>Prevucite slike ovde ili kliknite za dodavanje</p>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleGalerijaChange}
                style={{ marginTop: "10px" }}
              />
            </div>
          </Modal>
        </div>
      </div>
      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
        width="auto"
      >
        <ImageGallery
          items={slikeZaGaleriju}
          showThumbnails={false}
          showFullscreenButton={false}
          showPlayButton={false}
          startIndex={currentIndex}
          onSlide={(index) => setCurrentIndex(index)}
        />
      </Modal>
    </div>
  );
};

export default GalerijaPage;
